import { Fragment } from 'react';

import {
  ActivityChangeOptions,
  ActivityItem,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';

export interface FlagsModuleData {
  targetingKeySelector?: string;
  stickyAssignments?: boolean;
  ignoreTargetingForSticky?: boolean;
  [key: string]: unknown;
}

const formatEnabled = (value: boolean | undefined): string => {
  return value ? 'Enabled' : 'Disabled';
};

const formatRandomizationUnit = (value: string | undefined): string => {
  if (!value) return 'Not set';
  const parts = value.split('/');
  return parts[parts.length - 1];
};

const hasChanged = (
  oldValue?: string | boolean | null,
  newValue?: string | boolean | null,
): boolean => {
  if (oldValue === newValue) return false;
  return oldValue !== newValue;
};

export const AudienceFlagsRender = ({ change }: ActivityChangeOptions) => {
  const oldValue = change.oldValue as FlagsModuleData | null;
  const newValue = change.newValue as FlagsModuleData | null;

  return (
    <Fragment>
      {hasChanged(
        oldValue?.targetingKeySelector,
        newValue?.targetingKeySelector,
      ) && (
        <ActivityItem.Section label="Updated randomization unit">
          <ActivityTagItem
            oldValue={formatRandomizationUnit(oldValue?.targetingKeySelector)}
            newValue={formatRandomizationUnit(newValue?.targetingKeySelector)}
          />
        </ActivityItem.Section>
      )}
      {hasChanged(
        oldValue?.stickyAssignments ?? false,
        newValue?.stickyAssignments ?? false,
      ) && (
        <ActivityItem.Section label="Updated sticky assignments">
          <ActivityTagItem
            oldValue={formatEnabled(oldValue?.stickyAssignments)}
            newValue={formatEnabled(newValue?.stickyAssignments)}
          />
        </ActivityItem.Section>
      )}
      {hasChanged(
        oldValue?.ignoreTargetingForSticky ?? false,
        newValue?.ignoreTargetingForSticky ?? false,
      ) && (
        <ActivityItem.Section label="Updated don't enforce inclusion criteria">
          <ActivityTagItem
            oldValue={formatEnabled(oldValue?.ignoreTargetingForSticky)}
            newValue={formatEnabled(newValue?.ignoreTargetingForSticky)}
          />
        </ActivityItem.Section>
      )}
    </Fragment>
  );
};
